import { Flex, Stack } from '@mantine/core';
import { useWindowSize } from 'react-use';
import { formatMonthDate } from '../../../../../../helpers/date-time-helpers';
import { HEIGHT_BREAKPOINTS } from '../../../../../../styles/breakpoints';
import { Text } from '../../../../../../ui-library/typography/typography';
import { Metric } from '../../../../strategy-v2.type';

export const FlowByPhaseChartTooltip = (props: any) => {
  const { active, payload, label, phaseMetadata, metric } = props;
  const { height } = useWindowSize();

  if (!active || !payload || !payload.length) {
    return null;
  }

  const isExpandedTooltip = height > parseInt(HEIGHT_BREAKPOINTS.md);

  return (
    <Stack
      gap={isExpandedTooltip ? 'xs' : 0}
      p={isExpandedTooltip ? 'xs' : '4px 8px'}
      style={{
        backgroundColor: 'white',
        borderRadius: 4,
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        maxWidth: 300,
      }}
    >
      <Text size="small" weight="medium">
        {formatMonthDate(label)}
      </Text>

      <Stack gap={isExpandedTooltip ? 'xs' : 0}>
        {payload.map((entry: any) => {
          const entryName = entry.name as string;
          if (!entryName) return null;

          const phase = phaseMetadata.find((p: any) => p.label === entryName);
          if (!phase) return null;

          return (
            <Flex key={phase.id} align="center" justify="space-between" gap={8}>
              <Flex align="center" gap={8}>
                <div
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: phase.color,
                  }}
                />
                <Text size="small">{phase.label}</Text>
              </Flex>
              <Text size="small" weight="medium">
                {entry.value !== undefined ? Math.round(entry.value as number) : 'N/A'}{' '}
                {metric === Metric.Tasks ? 'tasks' : 'points'}
              </Text>
            </Flex>
          );
        })}
      </Stack>
    </Stack>
  );
};
